module.exports = __webpack_public_path__ + "img/bg.e5c684ce.png";